import { useMutation } from '@tanstack/react-query';
import { APIError } from '@data';
import { SubmitContactFormBody } from '@data/sdk/match';
import { MatchingApi } from '@data/utils/axios-instance';

export const useSubmitContactForm = () =>
  useMutation<void, APIError, SubmitContactFormBody>({
    mutationFn: async (submitContactFormBody) => {
      await MatchingApi.contactForm.submitContactForm({ submitContactFormBody });
    },
  });
